import { camelizeKeys } from "humps";
import { equals } from "ramda";
import { MOBILE_PAYMENTS_URL, STORE_BUCKET } from "api_urls";
import { getPrettyUrl, getQueryString } from "get_base_uri";
import { checkStatus, parseJSON, cloudfrontGetRequest, postRequest, } from "helpers/ajax_request";
import getEnv from "helpers/get_env";
import { transformCheckInfoApiResponse, transformMerchantInfoApiResponse, transformCreditCardPaymentApiResponse, } from "helpers/transforms/mobile_pay";
export function getMerchantInfo() {
    return fetch(STORE_BUCKET + "/" + getPrettyUrl() + "/mobile_payments.json", cloudfrontGetRequest())
        .then(checkStatus)
        .then(parseJSON)
        .then(camelizeKeys)
        .then(transformMerchantInfoApiResponse);
}
export function getCheckInfo() {
    var fetchUrl = equals(getEnv(), "development")
        ? // "https://run.mocky.io/v3/1ac44ab2-29e1-4e9b-9aee-4d1a0d7d5041" // paid check - mocky delete url: https://designer.mocky.io/manage/delete/1ac44ab2-29e1-4e9b-9aee-4d1a0d7d5041/1rFFEADqn312eHSNQcZKej55OZbNCNSWzP3w
            "https://run.mocky.io/v3/f138410d-200d-4e42-9e3a-5b4a5dfac7a8" // unpaid check - mocky delete url: https://designer.mocky.io/manage/delete/f138410d-200d-4e42-9e3a-5b4a5dfac7a8/tBOcOVVzfuGMC2YLfo6xvcQUG2fiMokm5Sxe
        : // "https://run.mocky.io/v3/306dd33b-1a5b-4849-b93f-8dfc681e9505" // unpaid check with comps and mandatory tip  - mocky delete url: https://designer.mocky.io/manage/delete/306dd33b-1a5b-4849-b93f-8dfc681e9505/TO6EvN5OTr1FQdKhCf9cE39wvRLYDjWpXCFf
            MOBILE_PAYMENTS_URL + "/" + getPrettyUrl() + "/checks" + getQueryString();
    return fetch(fetchUrl)
        .then(checkStatus)
        .then(parseJSON)
        .then(camelizeKeys)
        .then(transformCheckInfoApiResponse);
}
export function postCreditCardPayment(paymentInfo) {
    return fetch(MOBILE_PAYMENTS_URL + "/" + getPrettyUrl() + "/mobile_payments", postRequest(paymentInfo))
        .then(checkStatus)
        .then(parseJSON)
        .then(camelizeKeys)
        .then(transformCreditCardPaymentApiResponse);
}
